import { v4 as uuid } from "uuid"
import { StatusCode } from "../enums/status_code"

export class ResponseModel {
  data: string
  code: number
  message: string
  iscompressed: boolean
  correlationid: string

  constructor(
    data: string = "",
    code: number = StatusCode.Ok,
    message: string = "",
    iscompressed: boolean = true,
    correlationid: string = "",
  ) {
    this.data = data
    this.code = code
    this.message = message
    this.iscompressed = iscompressed
    this.correlationid = correlationid !== "" ? correlationid : uuid()
  }
}
